import React from 'lib/react';
import { EVGrid, makeStyles } from 'lib/components';
import Typography from 'commonComponents/typography';
import PropTypes from 'prop-types';
import { percentageValueFormatter } from '../Analytics.utils';

const useStyles = makeStyles(() => ({
  legendContainer: {
    maxWidth: '200px',
    minWidth: 'fit-content',
    width: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '8px',
    flex: 1,
    gap: '19px',
  },
  legendItem: {
    display: 'flex',
    gap: '8px',
    width: '100%',
    alignItems: 'center',
  },
  legendLabel: {
    whiteSpace: 'nowrap',
    flex: 1,
  },
  legendIcon: {
    borderRadius: '4px',
    border: '1px solid #000',
    minWidth: '20px',
    minHeight: '20px',
  },
}));

function PieChartLegend(props) {
  const classes = useStyles();
  const { lengendData } = props;
  return (
    <EVGrid className={classes.legendContainer}>
      {lengendData.map(({
        label, color, value, total,
      }) => (
        <EVGrid key={label} className={classes.legendItem}>
          <div style={{ backgroundColor: color }} className={classes.legendIcon} />
          <Typography variant="h5" fontColor="charcoal-900" className={classes.legendLabel}>{label}</Typography>
          <strong>{percentageValueFormatter({ value, total })}</strong>
        </EVGrid>
      ))}
    </EVGrid>
  );
}

PieChartLegend.propTypes = {
  lengendData: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    color: PropTypes.string,
    type: PropTypes.oneOf(['bar', 'line', 'dashedLine']),
  })).isRequired,
};

export default PieChartLegend;
